import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription, first } from 'rxjs';
import { ClaimsService } from '../../services/claims.service';
import { SiteService } from '../../services/site.service';
import { getQueryParamFromAncestorRoute } from '../../utilities/route.utilities';
import { IssuesNoPaymentsGridItemComponent } from '../issues/grid-item/payg/issues-no-payments-grid-item.component';
import { MasonryItemModel } from '../masonry/masonry.component';
import { BeyondEmergencyCreditItemComponent } from '../widgets/beyond-emergency-credit-item.component';
import { PaymentByTypeItemComponent } from '../widgets/payment-by-type-item.component';
import { PaymentTransmissionItemComponent } from '../widgets/payment-transmission-item.component';
import { DataService } from '../../services/data.service';
import { HistoryBillsGridItemComponent } from '../billing-portfolio/grid-item/history-bills-grid-item.component';
import { BillingPaymentsByTypeGridItemComponent } from '../billing-portfolio/grid-item/billing-payments-by-type-grid-item.component';
import { AgedDebtGridItemComponent } from '../billing-portfolio/grid-item/aged-debt-grid-item.component';
import { IssuesLatestBillEstimatedGridItemComponent } from '../issues/grid-item/billing/issues-latest-bill-estimated-grid-item.component';
import { AverageConsumptionGridItemComponent } from '../meter-portfolio/grid-item/average-consumption-grid-item.component';

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

    masonryItems: MasonryItemModel[] = [];

    clientId: number;
    selectedSiteId: number = 0;
    userName: string;
    userSiteId: number = 0;

    subscriptions: Subscription[] = [];
    isSuperUser: boolean = true;
    hasPayg: boolean = true;
    hasBilling: boolean = true;
    hasMetering: boolean = true;
    columnCount: number = 2;
    sites: any[] = [];


    constructor(
        private claimService: ClaimsService,
        private route: ActivatedRoute,
        private router: Router,
        private siteService: SiteService,
        private dataService: DataService
    ) {
        this.isSuperUser = this.claimService.isSuperUser();
        this.hasPayg = this.claimService.hasPaygFeature();
        this.hasBilling = this.claimService.hasBillingFeature();
        this.hasMetering = this.claimService.hasConsumptionFeature();

    }

    ngOnInit() {
        if (this.isSuperUser || this.hasPayg && !this.hasBilling) {
            this.masonryItems = [
                {
                    component: PaymentByTypeItemComponent
                },
                {
                    component: PaymentTransmissionItemComponent
                },
                {
                    component: BeyondEmergencyCreditItemComponent,
                    isExpandable: true
                },
                {
                    component: IssuesNoPaymentsGridItemComponent,
                    isExpandable: true
                }
            ]
        } else if (this.isSuperUser || this.hasBilling && !this.hasPayg) {
            this.masonryItems = [
                {
                    component: HistoryBillsGridItemComponent
                },
                {
                    component: BillingPaymentsByTypeGridItemComponent
                },
                {
                    component: AgedDebtGridItemComponent,
                },
                {
                    component: IssuesLatestBillEstimatedGridItemComponent,
                    isExpandable: true
                }
            ]
        } else if (this.isSuperUser || this.hasBilling && this.hasPayg) {
            this.masonryItems = [
                {
                    component: PaymentByTypeItemComponent
                },
                {
                    component: PaymentTransmissionItemComponent
                },
                {
                    component: HistoryBillsGridItemComponent
                },
                {
                    component: AgedDebtGridItemComponent
                }
            ]
        } else if (this.isSuperUser || this.hasMetering) {
            this.columnCount = 1;
            this.masonryItems = [
                {
                    component: AverageConsumptionGridItemComponent
                },
                
            ]
        }
        // update isExpandable per item, if data is resolved
        this.subscriptions.push(this.dataService.beyondEmergencyCreditItemComponentResolved.pipe(first()).subscribe(
            result => this.masonryItems.find(x => x.component == BeyondEmergencyCreditItemComponent).isExpandable = result)
        )
        this.subscriptions.push(this.dataService.issuesNoPaymentsGridItemComponentResolved.pipe(first()).subscribe(
            result => this.masonryItems.find(x => x.component == IssuesNoPaymentsGridItemComponent).isExpandable = result)
        )

        if (this.isSuperUser || this.hasBilling && !this.hasPayg) {
            this.subscriptions.push(this.dataService.issuesBillingLatestBillEstimatedGridItemComponentResolved.pipe(first()).subscribe(
                result => this.masonryItems.find(x => x.component == IssuesLatestBillEstimatedGridItemComponent).isExpandable = result)
            )
        }

        this.subscriptions.push(this.route
            .parent!
            .params
            .subscribe(params => {
                this.clientId = +params['clientId'];
                this.search();
            }));

        this.userSiteId = parseInt(getQueryParamFromAncestorRoute(this.route, 'siteId'));
        if (Number.isNaN(this.userSiteId) || this.userSiteId === undefined) { this.userSiteId = 0; }

        this.selectedSiteId = this.userSiteId;

        let storedClaims = this.route.parent.snapshot.data['claims'];
        for (var i = 0; i < storedClaims.length; i++) {
            if (storedClaims[i].key == 'name') {
                this.userName = storedClaims[i].value;
            }
        }
    }

    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    search() {
        this.siteService.all(this.clientId).then((result) => {
            this.sites = result;
        });
    }

    updateSite() {
        let queryParams: any = JSON.parse(JSON.stringify(this.route.snapshot.queryParams)) as any;
        if (this.selectedSiteId != undefined && this.selectedSiteId != null) queryParams.siteId = +this.selectedSiteId;
        this.router.navigate(['/portal/' + this.clientId.toString() + '/dashboard'], { queryParams: queryParams, replaceUrl: true });
    }
}
